export const productFilters = [
    {
        name: 'name',
        value: '',
        title: ''
    }
]
